import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  FormControl,
  InputGroup,
  Modal,
} from 'react-bootstrap';
import GrIntegrationService from '../../service/GrIntegrationService';
import Alert from '../alert/Alert';
import Confirm from '../confirm/Confirm';
import FieldSet from '../fieldset/FieldSet';
import Grid from '../grid/Grid';

class RefuseAccountServiceAddressesForm extends React.Component {
  constructor(props) {
    super(props);
    const { serviceAddresses = [], } = props;
    this.state = {
      statusMessage: undefined,
      statusStyle: undefined,
      show: undefined,
      isLoading: false,
      isConfirming: false,
      addresses: serviceAddresses.join('\n'),
    };
    this.serviceAddressesInput = undefined;
  }

  onChange = (event) => {
    const { value: addresses = '', } = event.currentTarget;
    this.setState(prevState => ({ ...prevState, addresses, }));
  };

  onDismiss = () => this.setState(prevState => ({ ...prevState, status: undefined, }));

  updateRefuseAccountServiceAddresses = () => {
    this.setState(
      prevState => ({ ...prevState, isLoading: true, }),
      () => {
        const { accountId, externalAccountId, } = this.props;
        const { addresses = '', } = this.state;
        const serviceAddresses = addresses.trim().split('\n');
        return GrIntegrationService.updateRefuseAccountServiceAddresses({
          accountId,
          serviceAddresses,
        })
          .then(() => this.setState(prevState => ({
            ...prevState,
            isLoading: false,
            isConfirming: false,
            statusMessage: `Service Addresses for account ${externalAccountId} successfully updated.`,
            statusStyle: 'success',
          })))
          .catch(err => this.setState(prevState => ({
            ...prevState,
            isLoading: false,
            isConfirming: false,
            statusMessage: `Uh oh there was an error updating service addresses. Error: \n ${err}`,
            statusStyle: 'error',
          })));
      }
    );
  };

  handleShow = () => this.setState(prevState => ({ ...prevState, show: true, }));

  handleClose = () => this.setState(prevState => ({ ...prevState, show: false, }));

  handleConfirm = () => this.setState(prevState => ({ ...prevState, isConfirming: true, }));

  handleCloseConfirm = () => this.setState(prevState => ({ ...prevState, isConfirming: false, }));

  buildRow = (serviceAddress = '') => ({
    raw: serviceAddress,
    value: [
      serviceAddress,
    ],
  });

  renderAlert = () => {
    const { statusMessage, statusStyle, } = this.state;
    if (statusMessage && (statusStyle === 'success')) {
      return (
        <Alert
          body={statusMessage}
          alertVariant="success"
          buttonVariant="outlne-success"
          header="Success"
          onDismiss={this.onDismiss}
          buttonText="Okay"
        />
      );
    }
    if (statusMessage && (statusStyle === 'error')) {
      return (
        <Alert
          body={statusMessage}
          alertVariant="danger"
          buttonVariant="outline-danger"
          header="Failure"
          onDismiss={this.onDismiss}
          buttonText="Okay"
        />
      );
    }
    return null;
  };

  renderBody = () => {
     
    const {
      serviceAddresses = [],
      externalAccountId,
    } = this.props;
    const {
      addresses = [],
      isLoading,
      isConfirming,
    } = this.state;
    return (
      <div className="container">
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Current Service Addresses" style={{ maxHeight: '300px', }}>
            <Grid
              headers={[ { display: 'Service Addresses', id: 'serviceAddress', }, ]}
              rows={serviceAddresses.map(serviceAddress => this.buildRow(serviceAddress))}
            />
          </FieldSet>
        </div>
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="New Service Addresses" style={{ maxHeight: '300px', }}>
            <label htmlFor="service-addresses">Place one service address on each line. The first service address in the list is displayed in receipts and notification emails.</label>
            <InputGroup>
              <FormControl
                ref={(c) => { this.serviceAddressesInput = c; }}
                as="textarea"
                aria-label="Place one service address on each line. The first service address in the list is displayed in receipts and notification emails."
                id="service-addresses"
                value={addresses}
                onChange={this.onChange}
              />
              <Button variant="success" onClick={this.handleConfirm}>
                Save Service Addresses
              </Button>
              <Confirm
                isLoading={isLoading}
                title="Update Service Addresses"
                content={[
                  `Are you sure you want to update the service addresses for this GR refuse account with external id ${externalAccountId}? `,
                  'The current service addresses [',
                  serviceAddresses.join(', '),
                  '] will be replaced by new service addresses [',
                  addresses.split('\n').join(', '),
                  '].',
                ].join('')}
                open={isConfirming}
                onClose={this.handleCloseConfirm}
                onYes={this.updateRefuseAccountServiceAddresses}
                onNo={this.handleCloseConfirm}
              />
            </InputGroup>
          </FieldSet>
        </div>
      </div>
    );
     
  };

  render() {
    const { title, } = this.props;
    const { show, } = this.state;
    return (
      <div>
        <Button variant="primary" onClick={() => this.handleShow()}>
          Service Addresses
        </Button>
        <Modal show={show} onHide={() => this.handleClose()} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              {title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderBody()}
            {this.renderAlert()}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

RefuseAccountServiceAddressesForm.defaultProps = {
  title: 'Service Addresses Form',
  serviceAddresses: [],
};

RefuseAccountServiceAddressesForm.propTypes = {
  accountId: PropTypes.string.isRequired,
  externalAccountId: PropTypes.string.isRequired,
  title: PropTypes.string,
  serviceAddresses: PropTypes.arrayOf(PropTypes.string),
};

export default RefuseAccountServiceAddressesForm;
